import React, {Component} from 'react';
import {Button} from 'material-ui';
import Dialog, {
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    withMobileDialog,
} from 'material-ui/Dialog';

class DeleteMenuItemDialog extends Component {

    render() {
        const {
            handleClose,
            open,
            classes,
            handleSubmit,
            menuItemsTreeData,
            node,
            path
        } = this.props;

        return (
            <Dialog
                open={open}
                onClose={handleClose}
            >
                <DialogTitle>{"Deletion confirmation"}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        This will remove the current menu item and ALL of its children!<br />
                        Are you sure you wish to proceed?
                    </DialogContentText>
                </DialogContent>
                <DialogActions className={classes.dialogActionsButtons}>
                    <Button onClick={handleClose} variant="raised">Cancel</Button>
                    <Button onClick={(e) => handleSubmit(menuItemsTreeData, node, path)} variant="raised" color="primary" type="submit" autoFocus>
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default withMobileDialog()(DeleteMenuItemDialog);


// WEBPACK FOOTER //
// ./src/containers/menus/DeleteMenuItemDialog.jsx